module.exports = __webpack_public_path__ + "img/invite-select.5b587575.png";